import type { Listing, Platform } from './types';

export function priceUSD(v: number | null): string {
  if (v === null) return '—';
  const cents = Math.round(v * 100) % 100 !== 0;
  return '$' + v.toLocaleString('en-US', {
    minimumFractionDigits: cents ? 2 : 0,
    maximumFractionDigits: cents ? 2 : 0,
  });
}

const cap = (s: string): string => (s ? s.charAt(0).toUpperCase() + s.slice(1) : s);

export function brandLabel(l: Pick<Listing, 'match_trace' | 'item_specifics'>): string {
  const mb = l.match_trace?.matched_brand;
  if (mb) return cap(mb);
  const isb = l.item_specifics['Brand']?.[0] ?? l.item_specifics['Marke']?.[0];
  if (isb) return isb;
  return 'không rõ hãng';
}

export function relativeAge(iso: string, now: number = Date.now()): string {
  const min = Math.floor((now - new Date(iso).getTime()) / 60_000);
  if (min < 1) return 'vừa xong';
  if (min < 60) return `${min} phút`;
  const h = Math.floor(min / 60);
  if (h < 24) return `${h} giờ`;
  const d = Math.floor(h / 24);
  if (d < 7) return `${d} ngày`;
  const dt = new Date(iso);
  return `${dt.getUTCDate()}/${dt.getUTCMonth() + 1}`;
}

export function auctionRemaining(iso: string | null, now: number = Date.now()): string | null {
  if (!iso) return null;
  const diff = new Date(iso).getTime() - now;
  if (diff <= 0) return 'đã kết thúc';
  const totalMin = Math.floor(diff / 60_000);
  const h = Math.floor(totalMin / 60);
  const d = Math.floor(h / 24);
  if (d >= 1) return `còn ${d} ngày ${h % 24} giờ`;
  if (h >= 1) return `còn ${h} giờ ${totalMin % 60} phút`;
  return `còn ${totalMin} phút`;
}

export function saleLabel(l: Pick<Listing, 'sale_type' | 'auction_ends_at'>): string {
  if (l.sale_type === 'fixed') return 'Mua ngay';
  const base = l.sale_type === 'auction_bin' ? 'Đấu giá + Mua ngay' : 'Đấu giá';
  const r = auctionRemaining(l.auction_ends_at);
  return r ? `${base} · ${r}` : base;
}

export function platformDisplayName(platform: Platform): string {
  switch (platform) {
    case 'ebay':
      return 'eBay';
    case 'poshmark':
      return 'Poshmark';
    case 'mercari':
      return 'Mercari';
    default:
      return platform;
  }
}
